module.exports = __webpack_public_path__ + "static/media/Starlish summary of Allegations.9d16f86a.pdf";